import { mapGetters } from 'vuex'
import localStorage from '@/mixins/localStorage';

export default {
    mixins: [ localStorage ],
    created() {
    },
    mounted() {
        this.SiteInfo = this.getSiteInfo;
        this.SiteLogo = this.SiteLogo;

    },
    data() {
        return {
            SiteInfo : {},
            SiteLogo : {}
        }
    },
    watch: {
        getSiteInfo: function(newValue, oldValue) {
            this.SiteInfo = newValue;
        },
        getSiteLogo: function(newValue, oldValue) {
            this.SiteLogo = newValue;
        }

    },
    computed: {
        ...mapGetters({
            getSiteInfo: 'common/getSiteInfo',
            getSiteLogo: 'common/getSiteLogo'
        }),
    },
    method: {
       /* checkSite(){
            this.$api.$common.getConfigInfo().then((res) => {
                this.$store.dispatch('common/initSiteInfo', {info : res.Data.Result.List[0]} );
            })
        }*/

    }
}
